import { Button, ButtonSize, ButtonVariant, E1Logo } from '@estimateone/frontend-components';
import { Action, AnalyticsEndpoint, Event, useAnalytics } from '../../../hooks/Analytics';
import { EntityId } from '@ascension/types';
import styles from './styles.scss';

type ItpSignupBannerNoNoticeboardProps = {
  slug: string;
  rfqId: EntityId;
  rfqHash: string;
  builderCompanyName: string;
};

export const ItpSignupBannerNoNoticeboard = ({
  slug,
  rfqId,
  rfqHash,
  builderCompanyName,
}: ItpSignupBannerNoNoticeboardProps) => {
  const { addEvent } = useAnalytics(Event.INTERACT, AnalyticsEndpoint.Itp);

  const handleClick = () => {
    addEvent({ action: Action.ITP_SIDE_BANNER_SIGNUP_CLICKED });
    /**
     * @see assets/src/js/itp/cta.js
     */
    window.dispatchEvent(
      new CustomEvent('itp_cta_signup_from_react_banner', { detail: { slug, rfqId, rfqHash } }),
    );
  };
  return (
    <div className={styles.bannerWrapper}>
      <div className={styles.contentContainer}>
        <E1Logo width={88} />
        <h2 className={styles.title}>
          Manage enquiries from {builderCompanyName} and unlock new tender opportunities
        </h2>
        <p className={styles.subheading}>Access the E1 Construction Network </p>
        <p>Create a free account with E1 and:</p>
        <ul className={styles.benefitList}>
          <li>
            <strong>Effortlessly manage enquiries:</strong> Respond to requests from{' '}
            <strong>{builderCompanyName}</strong> and other contractors.
          </li>
          <li>
            <strong>Showcase your company:</strong> Promote your company to potential contractors
            looking for additional pricing.
          </li>
          <li>
            <strong>Discover new tender opportunities:</strong> Download docs from leading
            Contractors seeking to expand their supply chain.
          </li>
          <li>
            <strong>Stay front of mind:</strong> Maintain a high response rate in{' '}
            <strong>{builderCompanyName}</strong>’s address book.
          </li>
          <li>
            <strong>Reasons for ‘Not Quoting’:</strong> Inform contractors about reasons for not
            pricing a tender.
          </li>
        </ul>
        <div className={styles.buttonContainer}>
          <Button variant={ButtonVariant.Primary} size={ButtonSize.Large} onClick={handleClick}>
            Create free account
          </Button>
        </div>
      </div>
    </div>
  );
};
